import cx from 'classnames/bind';
import React from 'react';
import styles from './BinarySwitch.scss';

const classNames = cx.bind(styles);

interface BinarySwitchProps {
    leftLabel: string;
    rightLabel: string;
    onClick?: (isLeftSelectedNow: boolean) => void;
    className?: string;
    selectedButtonClass?: string;
    freeButtonClass?: string;
    getAriaLabel?: (isLeftSideSelected: boolean) => string;
    isLeftSelected?: boolean;
}

export const BinarySwitch = React.forwardRef(
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    (props: BinarySwitchProps, ref?: React.RefObject<any>): JSX.Element => {
        const {
            className,
            leftLabel,
            rightLabel,
            freeButtonClass,
            selectedButtonClass,
            getAriaLabel,
            onClick,
            isLeftSelected = true,
        } = props;

        const onSwitchClick = () => {
            const newIsLeftSelected = !isLeftSelected;
            onClick && onClick(newIsLeftSelected);
        };

        const renderSide = (label: string, isSelected: boolean) => (
            <div
                className={classNames(
                    styles.pill,
                    isSelected
                        ? classNames(styles.selectedSide, selectedButtonClass)
                        : freeButtonClass
                )}>
                <span className={styles.pillText}>{label}</span>
            </div>
        );

        return (
            <div
                className={classNames(styles.switchContainer, className)}
                onClick={onSwitchClick}
                role="button"
                ref={ref}
                tabIndex={0}
                aria-label={getAriaLabel ? getAriaLabel(isLeftSelected) : ''}>
                {renderSide(leftLabel, isLeftSelected)}
                {renderSide(rightLabel, !isLeftSelected)}
            </div>
        );
    }
);
